import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppSelector } from "../../hooks/redux.hook";
import { UserService } from "../../_service";
import { CloseButton } from "../activity/close-button.component";
import I18 from "../atoms/i18";
import { Button } from "../button.component";
import RightSideModal from "../right-side-modal.component";

export function useManageBadgesModel() {
  const [showManageBadgesSidebar, setShowManageBadgesSidebar] = useState(false);
  const [badges, setBadges] = useState<any[]>([]);
  const [selectedBadgeIds, setSelectedBadgeIds] = useState<string[]>([]);
  const [selectedUserId, setSelectedUserId] = useState("");

  const { community } = useAppSelector((state) => {
    return {
      community: state.community,
    };
  });

  useEffect(() => {
    if (badges && badges.length > 0) {
      const selectedIds = badges
        .filter((badge: any) => badge.selected)
        .map((badge: any) => badge._id);
      setSelectedBadgeIds(selectedIds);
    }
  }, [badges, selectedUserId]);

  const handleBadgeSelection = (badgeId: string, isSelected: boolean) => {
    setSelectedBadgeIds((prev) => {
      if (isSelected) {
        return [...prev, badgeId];
      } else {
        return prev.filter((id) => id !== badgeId);
      }
    });
  };

  const manageBadgesOfUser = async () => {
    try {
      const response = await UserService.updateBadgesForUser(
        selectedUserId,
        community?.id,
        selectedBadgeIds
      );
      setBadges(response.badges);
      //   setShowManageBadgesSidebar(false);
      window.location.reload();
    } catch (error) {
      console.error("Failed to update badges for the user", error);
    }
  };

  const ManageBadgesSidebarCallback = useCallback(() => {
    return (
      <RightSideModal
        active={showManageBadgesSidebar}
        setActive={setShowManageBadgesSidebar}
        className="mt-2 max-w-2xl rounded-t-2xl bg-card md:mt-0 md:rounded-l-2xl md:rounded-tr-none">
        <div className="py-1-4 sticky top-0 z-10 flex items-center justify-between border-b border-border bg-card px-4">
          <span className="font-bold text-secondary-foreground/80">
            <I18>Badges</I18>
          </span>
          <CloseButton
            onClick={() => setShowManageBadgesSidebar(false)}
            type="primary"
          />
        </div>
        <div className="h-[calc(100vh-180px)] overflow-y-auto">
          <div className="grid grid-cols-1 gap-6 p-6 pb-24 md:grid-cols-3">
            {badges && badges.length > 0 ? (
              badges.map((badge: any) => (
                <div
                  key={badge._id}
                  className="flex flex-col items-center rounded-2xl bg-white p-4 shadow-md">
                  <div className="mb-4 flex flex-col items-center justify-center">
                    <div className="mb-2 flex h-24 w-24 items-center justify-center rounded-xl border border-gray-200">
                      <img
                        src={badge.imageUrl}
                        alt={badge.title}
                        className="h-20 w-20 object-contain"
                      />
                    </div>
                  </div>
                  <label className="flex cursor-pointer items-center gap-2">
                    <input
                      type="checkbox"
                      className="form-checkbox h-4 w-4 cursor-pointer text-primary"
                      checked={selectedBadgeIds.includes(badge._id)}
                      onChange={(e) =>
                        handleBadgeSelection(badge._id, e.target.checked)
                      }
                    />
                    <span className="text-sm font-medium text-gray-700">
                      {badge.title}
                    </span>
                  </label>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center text-gray-500">
                <I18>No badges available</I18>
              </div>
            )}
          </div>
        </div>
        <div className="fixed bottom-0 w-full border-t border-border bg-card p-4 md:w-3/5 lg:w-[38%]">
          <div className="flex justify-between">
            <Button
              onClick={() => setShowManageBadgesSidebar(false)}
              className="rounded-md px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              isCancelType={true}
              label="Cancel"
            />
            <Button
              onClick={manageBadgesOfUser}
              disabled={badges.length === 0}
              className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:bg-primary/90"
              label="Update Badges"
            />
          </div>
        </div>
      </RightSideModal>
    );
  }, [
    showManageBadgesSidebar,
    setShowManageBadgesSidebar,
    badges,
    selectedBadgeIds,
  ]);
  return useMemo(
    () => ({
      manageBadgesModelState: {
        setShowManageBadgesSidebar,
        setBadges: setBadges,
        setSelectedUserId,
      },
      ManageBadgesModel: ManageBadgesSidebarCallback,
      setBadges: setBadges,
    }),
    [setShowManageBadgesSidebar, ManageBadgesSidebarCallback, setSelectedUserId]
  );
}
